import { useState, useEffect } from "react";
import Modal from "react-modal";
import { IMaskInput } from "react-imask";
import "./style.css";

import Sidebar from "../../componente/sidebar";
import PageHeader from "../../componente/topbar";
import AutoComplete from "../../componente/cadastro/autocomplete";
import SmartSelect from "../../componente/cadastro/smartselect/index.jsx";

import {
    imagensCategoria,
    imagensSaldo,
    imagensPessoa
} from "../../assets/mapImagens";

import { DateTime } from "luxon";
import api from "../../services/api";
import { useAppContext } from "../../pages/context/AppContext.jsx";

Modal.setAppElement("#root");

function Lancamento() {

    const { codusuario } = useAppContext();

    /* ================= ESTADOS ================= */

    const [busca, setBusca] = useState("");

    const [editando, setEditando] = useState(null);
    const [sidebarAberto, setSidebarAberto] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [tipoModal, setTipoModal] = useState(null);

    const hoje = DateTime.now();
    const primeiroDiaMes = hoje.startOf("month");

    const [dataInicio, setDataInicio] = useState(
        primeiroDiaMes.toISODate()
    );

    const [dataFim, setDataFim] = useState(
        hoje.toISODate()
    );

    const [lancamentos, setLancamentos] = useState([]);

    const formatDate = (dateStr) => dateStr ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("dd/MM/yyyy") : "";

    const obterTiposLancamento = (saldo) => {

        const tipoSaldo = saldo?.index;

        switch (tipoSaldo) {

            case 0:
                return [
                    { value: "DI", label: "Dinheiro" },
                    { value: "PR", label: "Promissória" }
                ];

            case 1:
                return [
                    { value: "PX", label: "Pix" },
                    { value: "CC", label: "Crédito" },
                    { value: "CD", label: "Débito" },
                    { value: "TF", label: "Transferência" }
                ];

            case 2:
                return [
                    { value: "PX", label: "Pix" },
                    { value: "TF", label: "Transferência" }
                ];

            default:
                return [];
        }
    };

    /* ================= BUSCAR LANÇAMENTOS ================= */

    const fetchLancamentos = async () => {
        const response = await api.get("v1/lancamento", {
            params: {
                codusuario,
                dt1: dataInicio,
                dt2: dataFim
            }
        });
        setLancamentos(response.data);
    };

    useEffect(() => {
        fetchLancamentos();
    }, [dataInicio, dataFim]);

    /* ================= BUSCAS AUTOCOMPLETE ================= */

    const fetchCategorias = async (query) => {
        const response = await api.get("v1/busca/categoria", {
            params: {
                descricao: query,
                codusuario
            }
        });
        return response.data.map(c => ({
            id: c.id,
            label: c.label,
            index: c.indexcategoria
        }));
    };

    const fetchSaldos = async (query) => {
        const response = await api.get("v1/busca/saldo", {
            params: {
                saldo: query,
                codusuario
            }
        });
        return response.data.map(s => ({
            id: s.id,
            label: s.label,
            index: s.indexsaldo
        }));
    };

    const fetchPessoas = async (query) => {
        const response = await api.get("v1/busca/pessoa", {
            params: {
                pessoa: query,
                codusuario
            }
        });
        return response.data.map(p => ({
            id: p.id,
            label: p.label,
            index: p.indexpessoa
        }));
    };

    const lancamentosFiltrados = lancamentos.filter(l => {

        const texto = busca.toLowerCase();

        return (
            l.descricao?.toLowerCase().includes(texto) ||
            l.categoria?.toLowerCase().includes(texto) ||
            l.pessoa?.toLowerCase().includes(texto) ||
            l.saldo?.toLowerCase().includes(texto) ||
            String(l.valor)?.toLowerCase().includes(texto)
        );
    });

    /* ================= TOTALIZADORES ================= */

    const receitas = lancamentosFiltrados
        .filter(l => l.sai === "N")
        .reduce((acc, l) => acc + Number(l.valor), 0);

    const despesas = lancamentosFiltrados
        .filter(l => l.sai === "S")
        .reduce((acc, l) => acc + Number(l.valor), 0);

    const totalGeral = receitas - despesas;

    const formatar = (v) =>
        Number(v || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });

    /* ================= FORM ================= */

    const initialForm = {
        parcela: 1,
        valor: "",
        descricao: "",
        saldoOrigem: null,
        saldoDestino: null,
        categoria: null,
        pessoa: null,
        tipolancOrigem: "",
        tipolancDestino: ""
    };

    const [form, setForm] = useState(initialForm);

    const abrirModal = (tipo) => {

        setEditando(null); // importante

        setTipoModal(tipo);
        setForm(initialForm);
        setModalOpen(true);

    };

    const abrirEditar = async (l) => {

        const dados = await buscarUmLancamento(l.codlancamento);

        console.log("codlancamento: " + dados.codlancamento);

        setEditando(dados.codlancamento);

        setTipoModal(
            dados.tipo === "R"
                ? "R"
                : dados.tipo === "D"
                    ? "D"
                    : "T"
        );

        setForm({
            tipo: dados.tipo,
            sai: dados.sai,
            valor: String(dados.valor ?? ""),
            descricao: dados.descricao,
            tipolancOrigem: dados.tipolancorigem ?? "",
            tipolancDestino: dados.tipolancdestino ?? "",
            saldoOrigem: dados.codsaldo
                ? {
                    id: dados.codsaldo,
                    label: dados.saldo,
                    index: dados.indexsaldo
                }
                : null,
            saldoDestino: dados.codsaldo
                ? {
                    id: dados.codsaldo,
                    label: dados.saldo,
                    index: dados.indexsaldodestino
                }
                : null,
            categoria: dados.codcategoria
                ? {
                    id: dados.codcategoria,
                    label: dados.categoria,
                    index: dados.indexcategoria
                }
                : null,
            pessoa: dados.codpessoa
                ? {
                    id: dados.codpessoa,
                    label: dados.pessoa,
                    index: dados.indexpessoa
                }
                : null
        });
        setModalOpen(true);
    };

    const buscarUmLancamento = async (codlancamento) => {

        const response = await api.get("v1/lancamentoum", {
            params: {
                codlancamento,
                codusuario
            }
        });

        return response.data;

    };

    const salvar = async () => {
        const dt1 = new Date();
        const date1 =
            dt1.getFullYear() +
            "-" +
            (dt1.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt1.getDate().toString().padStart(2, "0");

        const time1 =
            dt1.getHours().toString().padStart(2, "0") +
            ":" +
            dt1.getMinutes().toString().padStart(2, "0");

        const dados = {
            dtalteracao: `${date1}T${time1}`,
            dtlanc: `${date1}T${time1}`,
            dtvenc: `${date1}T${time1}`,
            codusuario,
            tipo: tipoModal,
            descricao: form.descricao,
            valor: form.valor,
            parc: form.parcela,
            tipolancorigem: form.tipolancOrigem,
            tipolancdestino: form.tipolancDestino,
            codcategoria: form.categoria?.id,
            codpessoa: form.pessoa?.id,
            codsaldoorigem: form.saldoOrigem?.id,
            codsaldodestino: form.saldoDestino?.id,
            sai: tipoModal === 'R' ? 'N' : tipoModal === 'D' ? 'S' : form.sai
        };
        if (editando) {

            await api.put("v1/lancamento", {
                ...dados,
                codlancamento: editando
            });

        } else {

            await api.post("v1/lancamento", dados);

        }
        setModalOpen(false);
        fetchLancamentos();
    };

    /* ================= UI ================= */

    const excluirLancamentoLista = async (e, codlancamento) => {
        e.stopPropagation();

        const confirmar = window.confirm("Deseja excluir este lançamento?");
        if (!confirmar) return;

        await api.delete("v1/lancamento", {
            params: {
                codlancamento,
                codusuario
            }
        });

        fetchLancamentos();
    };

    return (
        <>
            <PageHeader
                titulo="Lançamentos"
                subtitulo="Gerencie suas movimentações"
                abrirMenu={() => setSidebarAberto(true)}

                filtroData
                dataInicio={dataInicio}
                dataFim={dataFim}
                onDataInicioChange={setDataInicio}
                onDataFimChange={setDataFim}

                botaoAdicionar
                textoAdicionar="Novo Lançamento"

                onAdicionar={() =>
                    setTipoModal(prev => prev === "menu" ? null : "menu")
                }

                adicionarConteudo={
                    tipoModal === "menu" && (
                        <div className="dropdown-tipo">

                            <div onClick={() => abrirModal("R")}>
                                💰 Receita
                            </div>

                            <div onClick={() => abrirModal("D")}>
                                💸 Despesa
                            </div>

                            <div onClick={() => abrirModal("T")}>
                                🔄 Transferência
                            </div>

                        </div>
                    )
                }
            >
                {/* CAMPO DE BUSCA */}
                <input
                    type="text"
                    placeholder="Buscar lançamento..."
                    value={busca}
                    onChange={(e) => setBusca(e.target.value)}
                    className="input-busca"
                />
            </PageHeader>

            <div className="lancamento-container">

                <Sidebar
                    aberto={sidebarAberto}
                    fechar={() => setSidebarAberto(false)}
                />

                <div className="lancamento-wrapper">
                    {/* LISTAGEM */}

                    <div className="lancamento-list">

                        {lancamentosFiltrados.map(l => (

                            <div
                                key={l.codlancamento}
                                className={`lancamento-card ${l.tipo === "R"
                                        ? "card-receita"
                                        : l.tipo === "D"
                                            ? "card-despesa"
                                            : "card-transferencia"
                                    }`}
                                onClick={() => abrirEditar(l)}
                            >

                                <div className="lancamento-content">

                                    <div className="lanc-top">

                                        <div className="lanc-titulo">

                                            <strong className="descricao">
                                                {l.descricao}
                                            </strong>

                                            <span className={`badge-tipo badge-${l.tipo}`}>
                                                {l.tipo === "R" && "💰 Receita"}
                                                {l.tipo === "D" && "💸 Despesa"}
                                                {l.tipo === "T" && "🔄 Transferência"}
                                            </span>

                                        </div>

                                        <strong
                                            className={
                                                l.sai === "S"
                                                    ? "valor-saida"
                                                    : "valor-entrada"
                                            }
                                        >
                                            {formatar(l.valor)}
                                        </strong>

                                    </div>

                                    <div className="lanc-middle">

                                        <div className="linha-info">
                                            <img src={imagensCategoria[l.indexcategoria]} alt="" />
                                            <span>{l.categoria}</span>
                                        </div>

                                        <div className="linha-info">
                                            <img src={imagensPessoa[l.indexpessoa]} alt="" />
                                            <span>{l.pessoa}</span>
                                        </div>

                                    </div>

                                    <div className="lanc-bottom">

                                        <div className="linha-info">
                                            <img src={imagensSaldo[l.indexsaldo]} alt="" />
                                            <span>
                                                {l.saldo}
                                            </span>
                                        </div>

                                        <span className="tipo-pagamento">
                                            {l.tipolanc}
                                        </span>

                                        <span className="data">
                                            {formatDate(l.dtvenc)}
                                            {l.parc !== "1/1" && ` • ${l.parc}x`}
                                        </span>

                                    </div>

                                </div>

                                <button
                                    className="btn-excluir"
                                    onClick={(e) =>
                                        excluirLancamentoLista(e, l.codlancamento)
                                    }
                                >
                                    🗑
                                </button>

                            </div>
                        ))}
                    </div>


                    {/* TOTALIZADOR */}

                    <div className="totalizador">
                        <div>
                            <span>Receitas</span>
                            <strong className="valor-entrada">
                                {formatar(receitas)}
                            </strong>
                        </div>

                        <div>
                            <span>Despesas</span>
                            <strong className="valor-saida">
                                {formatar(despesas)}
                            </strong>
                        </div>

                        <div>
                            <span>Total</span>
                            <strong>{formatar(totalGeral)}</strong>
                        </div>
                    </div>
                </div>

                {/* ================= MODAL ================= */}

                <Modal
                    isOpen={modalOpen}
                    onRequestClose={() => setModalOpen(false)}
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <div className="modal-header">
                        <h3>
                            {editando ? "Editar Lançamento" : (
                                <>
                                    {tipoModal === "R" && "Nova Receita"}
                                    {tipoModal === "D" && "Nova Despesa"}
                                    {tipoModal === "T" && "Nova Transferência"}
                                </>
                            )}
                        </h3>
                    </div>

                    <div className="modal-body">
                        {tipoModal !== "T" && (
                            <>
                                <div className="modal-row">
                                    {!editando && (
                                        <input
                                            type="number"
                                            placeholder="Parcelas"
                                            value={form.parcela}
                                            onChange={(e) =>
                                                setForm({ ...form, parcela: e.target.value })
                                            }
                                        />)}


                                    <IMaskInput
                                        mask={Number}
                                        scale={2}
                                        thousandsSeparator="."
                                        radix=","
                                        padFractionalZeros={true}
                                        normalizeZeros={true}
                                        inputMode="decimal" // 👈 teclado numérico no mobile
                                        type="text" // 👈 importante (NÃO usar number)
                                        placeholder="Valor"
                                        value={form.valor}
                                        onAccept={(value) =>
                                            setForm({ ...form, valor: value })
                                        }
                                    />
                                </div>

                                <input
                                    type="text"
                                    placeholder="Descrição"
                                    value={form.descricao}
                                    onChange={(e) =>
                                        setForm({ ...form, descricao: e.target.value })
                                    }
                                />

                                <SmartSelect
                                    txtLabel="Categoria"
                                    fetchData={fetchCategorias}
                                    onSelect={(item) =>
                                        setForm({ ...form, categoria: item })
                                    }
                                    initialValue={form.categoria}
                                    imagens={imagensCategoria}
                                />

                                <SmartSelect
                                    txtLabel="Saldo"
                                    fetchData={fetchSaldos}
                                    imagens={imagensSaldo}
                                    initialValue={form.saldoOrigem}
                                    onSelect={(item) =>
                                        setForm({
                                            ...form,
                                            saldoOrigem: item,
                                            tipolancOrigem: ""
                                        })
                                    }
                                    getOpcoesExtras={obterTiposLancamento}
                                    valorExtraSelecionado={
                                        form.tipolancOrigem
                                    }
                                    onSelectExtra={(saldo, opcao) =>
                                        setForm({
                                            ...form,
                                            saldoOrigem: saldo,
                                            tipolancOrigem: opcao.value
                                        })
                                    }
                                />

                                <SmartSelect
                                    txtLabel="Pessoa"
                                    fetchData={fetchPessoas}
                                    onSelect={(item) =>
                                        setForm({ ...form, pessoa: item })
                                    }
                                    initialValue={form.pessoa}
                                    imagens={imagensPessoa}
                                />
                            </>
                        )}

                        {tipoModal === "T" && (
                            <>
                                <IMaskInput
                                    mask={Number}
                                    scale={2}
                                    thousandsSeparator="."
                                    radix=","
                                    padFractionalZeros={true}
                                    normalizeZeros={true}
                                    inputMode="decimal" // 👈 teclado numérico no mobile
                                    type="text" // 👈 importante (NÃO usar number)
                                    placeholder="Valor"
                                    value={form.valor}
                                    onAccept={(value) =>
                                        setForm({ ...form, valor: value })
                                    }
                                />

                                <input
                                    type="text"
                                    placeholder="Descrição"
                                    value={form.descricao}
                                    onChange={(e) =>
                                        setForm({ ...form, descricao: e.target.value })
                                    }
                                />
                                {editando ? (<>
                                    {form.sai === 'S' ? (
                                        <SmartSelect
                                            txtLabel="Saldo"
                                            fetchData={fetchSaldos}
                                            onSelect={(item) =>
                                                setForm({
                                                    ...form,
                                                    saldoOrigem: item,
                                                    tipolancOrigem: ""
                                                })
                                            }
                                            initialValue={form.saldoOrigem}
                                            imagens={imagensSaldo}
                                        />
                                    ) : (
                                        <SmartSelect
                                            txtLabel="Saldo"
                                            fetchData={fetchSaldos}
                                            onSelect={(item) =>
                                                setForm({
                                                    ...form,
                                                    saldoDestino: item,
                                                    tipolancDestino: ""
                                                })
                                            }
                                            initialValue={form.saldoDestino}
                                            imagens={imagensSaldo}
                                        />
                                    )}
                                </>) : (<>
                                    <SmartSelect
                                        txtLabel="Saldo"
                                        fetchData={fetchSaldos}
                                        imagens={imagensSaldo}
                                        initialValue={form.saldoOrigem}
                                        onSelect={(item) =>
                                            setForm({
                                                ...form,
                                                saldoOrigem: item,
                                                tipolancOrigem: ""
                                            })
                                        }
                                        getOpcoesExtras={obterTiposLancamento}
                                        valorExtraSelecionado={
                                            form.tipolancOrigem
                                        }
                                        onSelectExtra={(saldo, opcao) =>
                                            setForm({
                                                ...form,
                                                saldoOrigem: saldo,
                                                tipolancOrigem: opcao.value
                                            })
                                        }
                                    />

                                    <SmartSelect
                                        txtLabel="Saldo Destino"
                                        fetchData={fetchSaldos}
                                        imagens={imagensSaldo}
                                        initialValue={form.saldoDestino}
                                        onSelect={(item) =>
                                            setForm({
                                                ...form,
                                                saldoDestino: item,
                                                tipolancDestino: ""
                                            })
                                        }
                                        getOpcoesExtras={obterTiposLancamento}
                                        valorExtraSelecionado={
                                            form.tipolancDestino
                                        }
                                        onSelectExtra={(saldo, opcao) =>
                                            setForm({
                                                ...form,
                                                saldoDestino: saldo,
                                                tipolancDestino: opcao.value
                                            })
                                        }
                                    />
                                </>
                                )}

                                <SmartSelect
                                    txtLabel="Pessoa"
                                    fetchData={fetchPessoas}
                                    onSelect={(item) =>
                                        setForm({ ...form, pessoa: item })
                                    }
                                    initialValue={form.pessoa}
                                    imagens={imagensPessoa}
                                />
                            </>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button
                            className="btn-cancelar"
                            onClick={() => setModalOpen(false)}
                        >
                            Cancelar
                        </button>

                        <button
                            className="btn-salvar"
                            onClick={salvar}
                        >
                            Salvar
                        </button>
                    </div>
                </Modal>
            </div>
        </>
    );
}

export default Lancamento;